import { render, staticRenderFns } from "./Detalhes_Denuncia.vue?vue&type=template&id=58f238a6&"
import script from "./Detalhes_Denuncia.vue?vue&type=script&lang=js&"
export * from "./Detalhes_Denuncia.vue?vue&type=script&lang=js&"
import style0 from "./Detalhes_Denuncia.vue?vue&type=style&index=0&id=58f238a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports